import React, { useCallback, useState, useEffect, useRef } from "react";
import { useDropzone } from "react-dropzone";
import commentIcon from "../../../../assets/svg/comment.svg";
import vector71Icon from "../../../../assets/svg/Vector 71.svg";
import viewIcon from "../../../../assets/svg/view.svg";
import {
  Form,
  Image,
  Grid,
  Table,
  Icon,
  Button,
  Comment,
  CommentGroup,
  CommentMetadata,
  Segment,
  Divider,
  Header,
  GridColumn,
  GridRow,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  List,
  Message,
  Popup,
  Dropdown,
} from "semantic-ui-react";
import { useFormik } from "formik";
import { Wasteform, AuditLog } from "../../../../api";
const auditLogController = new AuditLog();
import { useAuth } from "../../../../hooks";
import { PERIODS } from "../../../../utils";
import {
  formatDateView,
  formatDateHourCompleted,
} from "../../../../utils/formatDate";
import { BasicModal } from "../../../Shared";
import { initialValues, validationSchema } from "./WasteForm.form";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { decrypt, encrypt } from "../../../../utils/cryptoUtils";
import "./WasteForm.scss";
import { useLanguage } from "../../../../contexts";
import {
  disposalMethods,
  determineWasteUnits,
  wasteCodes,
} from "../../../../utils/dataAndFormulas/wasteForms";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Importa el CSS de react-toastify
import { formatInvoiceQuantity } from "../../../../utils/invoiceFormat";

const MAX_INVOICE_FILES = 20;
const MAX_INVOICE_FILE_SIZE = 10 * 1024 * 1024; // 10 MB, igual que el backend
import {
  isAdmin,
  isEditor,
  isReviewer,
  isMaster,
} from "../../../../utils/checkPermission";
const wasteFormController = new Wasteform();

const PERIOD_NUM_TO_NAME = {
  "01": "January", "1": "January",
  "02": "February", "2": "February",
  "03": "March", "3": "March",
  "04": "April", "4": "April",
  "05": "May", "5": "May",
  "06": "June", "6": "June",
  "07": "July", "7": "July",
  "08": "August", "8": "August",
  "09": "September", "9": "September",
  "10": "October",
  "11": "November",
  "12": "December",
};

export function WasteForm(props) {
  const {
    onClose,
    onReload,
    wasteForm,
    siteSelected,
    year,
    period,
    configFormData,
    unitsRecorded,
  } = props;
  const { accessToken } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [listPeriods, setListPeriods] = useState([]);
  const [yearComplete, setYearComplete] = useState(false);
  const [newFiles, setNewFiles] = useState({});
  const [showConfirm, setShowConfirm] = useState(false);
  const [unitEditEnabled, setUnitEditEnabled] = useState(false);
  const { user } = useAuth();

  // Lector de documentos de residuos
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [invoiceResults, setInvoiceResults] = useState([]);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [bulkSaveLoading, setBulkSaveLoading] = useState(false);
  const [bulkSaveResults, setBulkSaveResults] = useState(null);
  const [appliedIndexes, setAppliedIndexes] = useState(new Set());
  // Multi-comprobante: número de comprobante tipeado por el usuario para cada
  // fila en conflicto (mismo tipo+período ya aplicado), y los números ya
  // usados en el sitio para ofrecerlos en el selector (mismo patrón que
  // meterNames/existingMeterNames en EnergyForm.js).
  const [voucherNumbers, setVoucherNumbers] = useState({});
  const [existingVoucherNumbers, setExistingVoucherNumbers] = useState([]);
  const invoiceInputRef = useRef(null);
  const pendingInvoicePeriodRef = useRef(null);
  const bulkSaveResultsRef = useRef(null);

  // Verificar si el usuario puede editar unidades (admin o master)
  const canEditUnits = isAdmin(user.role) || isMaster(user.role);

  // Método de disposición por defecto configurado por campo (Form.fields[].defaultDisposalMethod),
  // usado para precargar el dropdown al crear un período nuevo
  const disposalMethodDefaults = (configFormData?.fields || []).reduce(
    (acc, field) => {
      if (field.defaultDisposalMethod) {
        acc[field.name] = field.defaultDisposalMethod;
      }
      return acc;
    },
    {},
  );

  const location = useLocation();

  const { translations, language } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  if (!siteSelected) {
    // // Manejo de caso donde no hay datos en state (por ejemplo, acceso directo a la URL)
    // return <div>No se encontraron detalles de producto.</div>;
  }

  const navigate = useNavigate();

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdateSite = (data, name) => {
    setFieldName(name);
    setTitleModal(`${t("comments")} ${data}`);
    onOpenCloseModal();
  };
  function setNestedError(obj, path, value) {
    const keys = path.split("."); // ["natural_gas", "unit"]
    let current = obj;
    keys.forEach((key, index) => {
      if (index === keys.length - 1) {
        current[key] = value; // asigna el mensaje de error al último nivel
      } else {
        if (!current[key]) current[key] = {}; // crea objeto si no existe
        current = current[key]; // baja al siguiente nivel
      }
    });
  }

  // Helper function to get approval status styling
  const getApprovalStatusStyle = (approvalStatus, isDisabled = false) => ({
    backgroundColor:
      approvalStatus === "approved"
        ? "#d4edda"
        : approvalStatus === "rejected"
        ? "#f8d7da"
        : approvalStatus === "pending"
        ? "#fff3cd"
        : "white",
    color:
      approvalStatus === "approved"
        ? "#155724"
        : approvalStatus === "rejected"
        ? "#721c24"
        : approvalStatus === "pending"
        ? "#856404"
        : "black",
    fontWeight: "bold",
    opacity: isDisabled ? 0.9 : 1,
  });

  // Helper function para limpiar el valor 0 cuando se hace focus en el campo
  const handleFocusNumberInput = (e) => {
    const value = e.target.value;
    if (value === "0" || value === 0) {
      e.target.value = "";
    }
  };

  const formik = useFormik({
    initialValues: initialValues(
      wasteForm,
      period,
      year,
      unitsRecorded,
      disposalMethodDefaults,
    ),
    // validationSchema: validationSchema(),

    validate: (values) => {
      const errors = {};
      try {
        validationSchema().validateSync(values, { abortEarly: false });
      } catch (err) {
        if (err.inner && err.inner.length > 0) {
          err.inner.forEach((e) => {
            errors[e.path] = e.message;
            setNestedError(errors, e.path, e.message);
            formik.setFieldTouched(e.path, true, false);
          });

          // 🔹 Mostrar toast resumido
          const fields = err.inner
            .map((e) => {
              if (e.path.includes(".unit"))
                return `${t("unit")} (${t(e.path.split(".")[0])})`;
              if (e.path.includes(".value"))
                return `${t("value")} (${t(e.path.split(".")[0])})`;
              return t(e.path);
            })
            .join(", ");
          toast.error(`Faltan completar datos: ${t(fields)}`);

          // 🔹 Scroll automático al primer error
          // 🔹 Scroll automático al primer error
          const firstErrorPath = err.inner[0]?.path;
          if (firstErrorPath) {
            const fieldId = firstErrorPath.replace(/\./g, "_");
            let fieldEl =
              document.getElementById(fieldId) ||
              document.querySelector(`[name="${firstErrorPath}"]`);

            if (!fieldEl) {
              fieldEl = Array.from(
                document.querySelectorAll("input, select, textarea")
              ).find(
                (el) =>
                  el.name?.includes(firstErrorPath) || el.id?.includes(fieldId)
              );
            }

            if (fieldEl) {
              // Buscar el contenedor con scroll
              let scrollContainer = fieldEl.parentElement;
              while (
                scrollContainer &&
                scrollContainer !== document.body &&
                scrollContainer.scrollHeight <= scrollContainer.clientHeight
              ) {
                scrollContainer = scrollContainer.parentElement;
              }

              // Calcular posición
              const rect = fieldEl.getBoundingClientRect();
              const offset = 150;

              if (scrollContainer && scrollContainer !== document.body) {
                const containerRect = scrollContainer.getBoundingClientRect();
                const scrollTopTarget =
                  scrollContainer.scrollTop +
                  (rect.top - containerRect.top) -
                  offset;
                scrollContainer.scrollTo({
                  top: scrollTopTarget,
                  behavior: "smooth",
                });
              } else {
                window.scrollTo({
                  top: rect.top + window.scrollY - offset,
                  behavior: "smooth",
                });
              }

              fieldEl.focus({ preventScroll: true });
            } else {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
          }
        }
      }
      return errors;
    },
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (!wasteForm) {
          formValue.creator_user = user._id;
          formValue.date = new Date();
          if (user?.site) {
            formValue.site = user.site;
          } else {
            if (siteSelected) {
              formValue.site = siteSelected;
            }
            // } else {
            //   // Desencriptar los datos recibidos
            //   // if (!wasteForm) {
            //   //   const siteData = decrypt(siteSelected);
            //   //   formValue.site = siteData;
            //   // }
            // }
          }
          // Recorrer el JSON
          for (const clave in newFiles) {
            if (newFiles.hasOwnProperty(clave)) {
              let filesField = await uploadFiles(newFiles[clave]);

              // Combina los archivos nuevos con los existentes
              let finalFilesField = [...formValue[clave].files, ...filesField];

              formValue[clave].files = finalFilesField;
            }
          }
          const response = await wasteFormController.createWasteForm(
            accessToken,
            formValue
          );
          if (response.code && response.code === 200) {
            toast.success("Formulario guardado correctamente!.");
          }

          //console.log(formValue);
        } else {
          // Detectar cambios de unidad para auditoría (solo admin/master)
          if (isAdmin(user.role) || isMaster(user.role)) {
            const unitChanges = [];
            for (const fieldName in formValue) {
              if (formValue[fieldName]?.unit !== undefined && wasteForm[fieldName]?.unit !== undefined) {
                if (formValue[fieldName].unit !== wasteForm[fieldName].unit) {
                  unitChanges.push({
                    field: fieldName,
                    oldUnit: wasteForm[fieldName].unit,
                    newUnit: formValue[fieldName].unit,
                    oldValue: wasteForm[fieldName].value,
                    newValue: formValue[fieldName].value,
                  });
                }
              }
            }

            // Registrar cambios de unidad en auditoría
            for (const change of unitChanges) {
              try {
                await auditLogController.createAuditLog(accessToken, {
                  documentId: wasteForm._id,
                  documentType: "waste",
                  field: change.field,
                  oldValue: { value: change.oldValue, unit: change.oldUnit },
                  newValue: { value: change.newValue, unit: change.newUnit },
                  changeType: "unit_change",
                  changedBy: user._id,
                  site: wasteForm.site?._id || wasteForm.site,
                  company: wasteForm.company,
                  year: wasteForm.year,
                  period: wasteForm.period,
                });
              } catch (auditError) {
                console.error("Error registrando auditoría:", auditError);
              }
            }

            if (unitChanges.length > 0) {
              toast.info(`${unitChanges.length} cambio(s) de unidad registrado(s) en auditoría`);
            }

            // Detectar cambios de método de disposición para auditoría
            const disposalMethodChanges = [];
            for (const fieldName in formValue) {
              if (formValue[fieldName]?.disposalMethod !== undefined && wasteForm[fieldName]?.disposalMethod !== undefined) {
                if (formValue[fieldName].disposalMethod !== wasteForm[fieldName].disposalMethod) {
                  disposalMethodChanges.push({
                    field: fieldName,
                    oldMethod: wasteForm[fieldName].disposalMethod,
                    newMethod: formValue[fieldName].disposalMethod,
                  });
                }
              }
            }

            // Registrar cambios de método de disposición en auditoría
            for (const change of disposalMethodChanges) {
              try {
                await auditLogController.createAuditLog(accessToken, {
                  documentId: wasteForm._id,
                  documentType: "waste",
                  field: change.field,
                  oldValue: { disposalMethod: change.oldMethod },
                  newValue: { disposalMethod: change.newMethod },
                  changeType: "disposal_method_change",
                  changedBy: user._id,
                  site: wasteForm.site?._id || wasteForm.site,
                  company: wasteForm.company,
                  year: wasteForm.year,
                  period: wasteForm.period,
                });
              } catch (auditError) {
                console.error("Error registrando auditoría de método de disposición:", auditError);
              }
            }

            if (disposalMethodChanges.length > 0) {
              toast.info(`${disposalMethodChanges.length} cambio(s) de método de disposición registrado(s) en auditoría`);
            }
          }

          // Recorrer el JSON
          for (const clave in newFiles) {
            if (newFiles.hasOwnProperty(clave)) {
              let filesField = await uploadFiles(newFiles[clave]);

              // Combina los archivos nuevos con los existentes
              let finalFilesField = [...formValue[clave].files, ...filesField];

              formValue[clave].files = finalFilesField;
            }
          }
          const response2 = await wasteFormController.updateWasteForm(
            accessToken,
            wasteForm._id,
            formValue
          );
          if (response2.code && response2.code === 200) {
            toast.success("Formulario guardado correctamente!.");
          }
        }

        // Retrasar el cierre del modal o el reload para dar tiempo a que la tostada se vea
        setTimeout(() => {
          onReload();
          if (onClose) {
            onClose();
          } else {
            // Después de guardar exitosamente, navegamos hacia atrás
            goBack();
          }
        }, 1000);
      } catch (error) {
        console.error(error);
      }
    },
  });

  // Comprobantes ya usados en el sitio — para ofrecerlos en el selector del
  // lector de facturas en vez de que el usuario tenga que tipear el número
  // cada vez (mismo patrón que existingMeterNames en EnergyForm.js).
  useEffect(() => {
    if (!showInvoiceModal) return;
    const siteId = siteSelected || user?.site;
    if (!siteId) return;
    (async () => {
      try {
        const years = [...new Set([
          formik.values.year,
          formik.values.year - 1,
        ].filter(Boolean))];
        const responses = await Promise.all(
          years.map((y) => wasteFormController.getWasteFormsBySiteAndYear(accessToken, siteId, y).catch(() => null))
        );
        const seen = new Map();
        responses.forEach((response) => {
          (response?.wasteForms || response || []).forEach((form) => {
            Object.keys(wasteCodes).flatMap((fieldName) => form[fieldName]?.records || []).forEach((r) => {
              const key = (r.voucherNumber || "").trim().toLowerCase();
              if (key && !seen.has(key)) seen.set(key, r.voucherNumber.trim());
            });
          });
        });
        setExistingVoucherNumbers(Array.from(seen.values()).sort());
      } catch (error) {
        console.error(error);
        setExistingVoucherNumbers([]);
      }
    })();
  }, [showInvoiceModal, formik.values.year, siteSelected]);

  const uploadFiles = async (filesToUpload, formValue, field) => {
    const formData = new FormData();
    Array.from(filesToUpload).forEach((file) => {
      formData.append("files", file);
    });

    // Luego de preparar los datos, puedes hacer la solicitud POST
    if (filesToUpload.length === 0) {
      //console.log("no hay archivos");
      //setErrorMessage("Por favor, selecciona al menos un archivo.");
      return;
    }

    try {
      // Realizar la solicitud POST al backend
      const response = await wasteFormController.uploadFileApi(
        accessToken,
        formData
      );
      if (response.code && response.code === 200) {
        return response.files;
      }
      return [];
    } catch (error) {
      //error
    }
  };

  const goBack = () => {
    navigate(`/admin/data/wasteforms`, {
      state: { siteSelected: siteSelected },
    });
  };

  const processInvoiceFiles = async (files) => {
    if (!files || files.length === 0) return;
    if (files.length > MAX_INVOICE_FILES) {
      toast.error(t("too_many_invoice_files") || `Se permiten hasta ${MAX_INVOICE_FILES} archivos por carga`);
      return;
    }
    const oversized = files.find((f) => f.size > MAX_INVOICE_FILE_SIZE);
    if (oversized) {
      toast.error(`"${oversized.name}" ${t("file_exceeds_max_size") || "supera el tamaño máximo permitido (10MB)"}`);
      return;
    }
    setInvoiceLoading(true);
    try {
      const formData = new FormData();
      files.forEach(f => formData.append("files", f));
      const result = await wasteFormController.readDocument(accessToken, formData);
      if (result.code === 200) {
        // La lectura automática no está disponible en este momento (servicio
        // externo) y el regex tampoco pudo leer nada: no abrimos el preview.
        if (result.aiUnavailable) {
          toast.info(t("invoice_ai_unavailable") || "No pudimos leer la factura automáticamente en este momento. Volvé a intentar en unos minutos.");
          setShowUploadModal(false);
          return;
        }
        // _rowId identifica cada fila de forma única: un mismo archivo puede
        // generar varias filas (manifiesto multi-residuo o varias facturas en un PDF).
        setInvoiceResults(result.results.map((r, i) => ({ ...r, _rowId: `${r.filename}#${i}` })));
        setAppliedIndexes(new Set());
        setShowUploadModal(false);
        setShowInvoiceModal(true);
      } else {
        toast.error(result.msg || t("could_not_read_document"));
      }
    } catch (err) {
      toast.error(err?.msg || err?.message || t("error_processing_invoice"));
    } finally {
      setInvoiceLoading(false);
    }
  };

  const handleInvoiceFileChange = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    e.target.value = "";
    await processInvoiceFiles(files);
  };

  const handleApplyInvoiceData = (result) => {
    if (!result) return;

    const periodName = result.period ? (PERIOD_NUM_TO_NAME[result.period] || result.period) : null;
    const yearNum = result.year ? parseInt(result.year, 10) : null;
    const yearIsChanging = yearNum && yearNum !== formik.values.year;

    if (yearNum) formik.setFieldValue("year", yearNum);

    if (periodName) {
      if (yearIsChanging) {
        pendingInvoicePeriodRef.current = periodName;
      } else {
        if (listPeriods.includes(periodName)) {
          formik.setFieldValue("period", periodName);
        } else {
          toast.warning(`El período ${t(periodName)} ya está cargado para este año.`);
        }
      }
    }

    // Aplicar cantidad al campo del tipo de residuo correspondiente
    if (result.wasteType && result.weight != null) {
      if (formik.values[result.wasteType] !== undefined) {
        // Si ya se aplicó otro resultado del mismo tipo+período (ej. 2 facturas
        // de "Materiales contaminados" en abril), se agrega como comprobante
        // adicional (records[]) y se suma, en vez de pisar el valor ya aplicado.
        const hasConflict = invoiceResults.some(
          (other) =>
            other._rowId !== result._rowId &&
            appliedIndexes.has(other._rowId) &&
            other.wasteType === result.wasteType &&
            other.period === result.period &&
            other.year === result.year
        );

        const voucherNumber = (voucherNumbers[result._rowId] || "").trim();
        if (hasConflict && !voucherNumber) {
          toast.warning(t("voucher_number_required") || "Ingresá un número de comprobante para agregar este registro.");
          return;
        }

        if (hasConflict) {
          const currentField = formik.values[result.wasteType] || {};
          const defaultVoucherLabel = t("voucher_default") !== "voucher_default" ? t("voucher_default") : "Comprobante 1";
          const prevRecords = currentField.records?.length
            ? currentField.records
            : (currentField.value != null
                ? [{
                    voucherNumber: currentField.filename || defaultVoucherLabel,
                    value: currentField.value,
                    source: currentField.sourceHash ? "invoice_reader" : "manual",
                    filename: currentField.filename,
                    sourceHash: currentField.sourceHash,
                  }]
                : []);

          // Idempotencia: mismo archivo ya aplicado antes en este campo → no se duplica.
          if (result.sourceHash && prevRecords.some((r) => r.sourceHash === result.sourceHash)) {
            toast.warning(t("voucher_record_already_applied") || "Esta factura ya se había agregado como comprobante — no se duplicó.");
            return;
          }

          const newRecords = [
            ...prevRecords,
            { voucherNumber, value: result.weight, source: "invoice_reader", filename: result.filename, sourceHash: result.sourceHash, addedBy: user?._id },
          ];
          const newTotal = newRecords.reduce((s, r) => s + (r.value || 0), 0);
          formik.setFieldValue(`${result.wasteType}.records`, newRecords);
          formik.setFieldValue(`${result.wasteType}.value`, newTotal);
        } else {
          formik.setFieldValue(`${result.wasteType}.value`, result.weight);
          formik.setFieldValue(`${result.wasteType}.sourceHash`, result.sourceHash);
          formik.setFieldValue(`${result.wasteType}.filename`, result.filename);
        }

        // Solo aplicar unidad si es válida en el formulario (g, kg, ton, L, m3)
        // "bultos", "UN", null → el usuario debe seleccionar la unidad manualmente
        const VALID_WASTE_UNITS = ["g", "kg", "ton", "L", "m3"];
        if (result.unit && VALID_WASTE_UNITS.includes(result.unit)) {
          formik.setFieldValue(`${result.wasteType}.unit`, result.unit);
        } else if (result.unit) {
          // Unidad del documento que el formulario no tiene (ej. "UN" en lámparas):
          // se avisa para que el usuario la cargue, en vez de dejarla vacía en silencio.
          toast.warning(t("invoice_unit_not_applied").replace("{{unit}}", result.unit));
        }
        if (result.disposalMethod) {
          formik.setFieldValue(`${result.wasteType}.disposalMethod`, result.disposalMethod);
        }
      } else {
        toast.warning(`El tipo de residuo "${result.wasteType}" no está disponible en este formulario.`);
      }
    }

    setAppliedIndexes(prev => {
      const next = new Set(prev);
      // Si ya hay otro del mismo período+año+wasteType aplicado, reemplazarlo
      if (result.wasteType && result.period && result.year) {
        const conflicting = invoiceResults.find(r =>
          r._rowId !== result._rowId &&
          next.has(r._rowId) &&
          r.wasteType === result.wasteType &&
          r.period === result.period &&
          r.year === result.year
        );
        if (conflicting) next.delete(conflicting._rowId);
      }
      next.add(result._rowId);
      return next;
    });
    toast.success(t("invoice_data_applied"));
  };

  // Crea o actualiza formularios agrupando los items aplicados por período+año
  const handleSaveAllInvoiceData = async () => {
    const VALID_WASTE_UNITS = ["g", "kg", "ton", "L", "m3"];
    const validItems = invoiceResults.filter(r => !r.error && r.wasteType && r.weight != null && r.period && r.year && appliedIndexes.has(r._rowId));
    if (!validItems.length) {
      toast.warning(t("no_valid_results_to_save") || "No hay resultados con período válido para guardar.");
      return;
    }

    setBulkSaveLoading(true);
    setBulkSaveResults(null);

    const siteId = siteSelected || user?.site;
    const summary = { saved: [], skipped: [], errors: [] };

    // Agrupar por período+año → un formulario por grupo
    const groups = new Map();
    for (const r of validItems) {
      const key = `${r.period}/${r.year}`;
      if (!groups.has(key)) groups.set(key, { period: r.period, year: r.year, items: [], filenames: new Set() });
      groups.get(key).items.push(r);
      if (r.filename) groups.get(key).filenames.add(r.filename);
    }

    for (const [, group] of groups.entries()) {
      const periodName = PERIOD_NUM_TO_NAME[String(group.period)] || group.period;
      const yearNum = parseInt(group.year, 10);
      const filenames = [...group.filenames].join(", ");

      try {
        const existsResponse = await wasteFormController.existsWasteFormByPeriodAndYear(
          accessToken, siteId, periodName, yearNum
        );

        // Construir campos de residuo (válidos para create y update). Si hay
        // más de un resultado del mismo wasteType en este batch (ej. 2
        // facturas de "plastic" el mismo mes), se cargan como records[] --
        // uno por factura, sumando el total -- en vez de que el último pise
        // al anterior (antes wasteFields[tipo] se reseteaba en cada vuelta).
        const itemsByType = new Map();
        for (const item of group.items) {
          if (!itemsByType.has(item.wasteType)) itemsByType.set(item.wasteType, []);
          itemsByType.get(item.wasteType).push(item);
        }

        const wasteFields = {};
        for (const [wasteType, items] of itemsByType.entries()) {
          const unit = items.find((i) => i.unit && VALID_WASTE_UNITS.includes(i.unit))?.unit;
          // Si el lector de facturas no detectó el método, usar el default configurado
          const disposalMethod = items.find((i) => i.disposalMethod)?.disposalMethod || disposalMethodDefaults[wasteType];

          if (items.length === 1) {
            wasteFields[wasteType] = { value: items[0].weight };
          } else {
            const records = items.map((i) => ({
              voucherNumber: i.filename || null,
              value: i.weight,
              source: "invoice_reader",
              addedBy: user?._id,
            }));
            wasteFields[wasteType] = {
              records,
              value: records.reduce((s, r) => s + (r.value || 0), 0),
            };
          }
          if (unit) wasteFields[wasteType].unit = unit;
          if (disposalMethod) wasteFields[wasteType].disposalMethod = disposalMethod;
        }

        if (existsResponse?.exist) {
          // Se trae el formulario existente para preservar records/code/reviews/
          // approvalStatus/files de cada campo -- wasteFields solo trae value/unit/
          // disposalMethod, y sin este merge el update pisaba el resto del
          // subdocumento (perdiendo por ejemplo los comprobantes ya cargados).
          const existingForm = await wasteFormController.getWasteForm(accessToken, existsResponse.id);
          const mergedFields = {};
          for (const wasteType in wasteFields) {
            const existingField = existingForm?.[wasteType] || {};
            const newField = wasteFields[wasteType];

            // Comprobantes/valor manual que ya hubiera antes de este guardado
            // masivo, para no perderlos -- mismo criterio que en el modal de
            // comprobantes: un valor manual sin records se trata como el
            // primer comprobante.
            const existingRecords = existingField.records?.length
              ? existingField.records
              : existingField.value
              ? [{ voucherNumber: t("previous_manual_value") || "Carga manual previa", value: existingField.value, source: "manual" }]
              : [];
            const newRecords = newField.records || [{ voucherNumber: null, value: newField.value, source: "invoice_reader", addedBy: user?._id }];

            if (existingRecords.length > 0) {
              const combinedRecords = [...existingRecords, ...newRecords];
              mergedFields[wasteType] = {
                ...existingField,
                ...newField,
                records: combinedRecords,
                value: combinedRecords.reduce((s, r) => s + (r.value || 0), 0),
              };
            } else {
              mergedFields[wasteType] = { ...existingField, ...newField };
            }
          }
          await wasteFormController.updateWasteForm(accessToken, existsResponse.id, mergedFields);
        } else {
          const payload = initialValues(null, periodName, yearNum, unitsRecorded, disposalMethodDefaults);
          payload.creator_user = user._id;
          payload.date = new Date();
          payload.site = siteId;
          Object.assign(payload, wasteFields);
          await wasteFormController.createWasteForm(accessToken, payload);
        }

        summary.saved.push({ period: periodName, year: yearNum, filename: filenames, count: group.items.length });
      } catch (err) {
        summary.errors.push({ period: periodName, year: yearNum, filename: filenames, msg: err?.msg || err?.message });
      }
    }

    setBulkSaveLoading(false);
    setBulkSaveResults(summary);
    if (summary.saved.length > 0) onReload?.();
    setTimeout(() => {
      const el = bulkSaveResultsRef.current;
      if (!el) return;
      const scrollContainer =
        el.closest(".scrolling.content") ||
        el.closest(".modal .content") ||
        el.closest(".content");
      if (scrollContainer) {
        scrollContainer.scrollTo({ top: scrollContainer.scrollHeight, behavior: "smooth" });
      } else {
        el.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }, 100);
  };

  // Generar una lista de años (por ejemplo, del 2000 al 2024)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 50 }, (_, i) => currentYear - i);

  useEffect(() => {
    (async () => {
      try {
        const response =
          await wasteFormController.getPeriodsWasteFormsBySiteAndYear(
            accessToken,
            siteSelected,
            formik.values.year
          );
        const periods = PERIODS.map((item) => item);
        const availablePeriods = periods
          .filter((period) => !response.periods.includes(period))
          .map((period) => period);

        setListPeriods(availablePeriods);

        if (availablePeriods.length === 0) {
          setYearComplete(true);
        } else {
          setYearComplete(false);
        }

        // Aplicar periodo pendiente desde lectura de documento (cuando el año cambió)
        if (pendingInvoicePeriodRef.current) {
          const pending = pendingInvoicePeriodRef.current;
          pendingInvoicePeriodRef.current = null;
          if (availablePeriods.includes(pending)) {
            formik.setFieldValue("period", pending);
          } else {
            toast.warning(`El período ${t(pending)} ya está cargado para el año ${formik.values.year}.`);
          }
        }
      } catch (error) {
        console.error(error);
        setListPeriods([]);
        setYearComplete(false);
        pendingInvoicePeriodRef.current = null;
      }
    })();
  }, [formik.values.year]);

  function findActiveFieldByName(nameToFind) {
    if (
      configFormData &&
      configFormData.fields &&
      configFormData.fields.length > 0
    ) {
      return configFormData.fields.some(
        (field) => field.name === nameToFind && field.active
      );
    }
    return true;
  }

  return (
    <Form className="waste-form" onSubmit={formik.handleSubmit}>
      {wasteForm ? (
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "12px" }}>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            backgroundColor: "#EDEDED", color: "#555",
            borderRadius: "999px", padding: "5px 14px",
            fontSize: "0.85rem", fontWeight: 600,
          }}>
            <Icon name="calendar alternate outline" style={{ margin: 0 }} />
            {wasteForm.date ? formatDateView(wasteForm.date) : "-"}
          </span>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            backgroundColor: "#EDEDED", color: "#555",
            borderRadius: "999px", padding: "5px 14px",
            fontSize: "0.85rem", fontWeight: 600,
          }}>
            <Icon name="user outline" style={{ margin: 0 }} />
            {wasteForm.creator_user
              ? wasteForm.creator_user.lastname
                ? wasteForm.creator_user.lastname + " " + wasteForm.creator_user.firstname
                : wasteForm.creator_user.email
              : "-"}
          </span>
        </div>
      ) : null}
      {!wasteForm ? (
        <>
          <Grid columns={2} divided>
            <GridRow style={{ display: "flex", gap: "20px" }}>
              {/* Año */}
              <GridColumn style={{ flex: 1 }}>
                <div
                // style={{ display: "flex", flexDirection: "column", gap: "4px" }}
                >
                  <div
                  //style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <label style={{ minWidth: "80px", fontWeight: 600 }}>
                      <span style={{ color: "red" }}>*</span> {t("year")}
                    </label>
                    <Form.Dropdown
                      placeholder={t("select")}
                      options={years.map((year) => ({
                        key: year,
                        text: year,
                        value: year,
                      }))}
                      selection
                      onChange={(_, data) =>
                        formik.setFieldValue("year", data.value)
                      }
                      value={formik.values.year}
                      error={!!formik.errors.year && !!formik.touched.year}
                      style={{ flex: 1 }}
                      name="year"
                    />
                  </div>
                  <div
                    style={{
                      color: "red",
                      fontSize: "0.8em",
                      minHeight: "1.2em",
                    }}
                  >
                    {formik.touched.year && formik.errors.year}
                  </div>
                </div>
              </GridColumn>

              {/* Periodo */}
              <GridColumn style={{ flex: 1 }}>
                <div
                // style={{ display: "flex", flexDirection: "column", gap: "4px" }}
                >
                  <div
                  //style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <label style={{ minWidth: "80px", fontWeight: 600 }}>
                      <span style={{ color: "red" }}>*</span> {t("period")}
                    </label>
                    <Form.Dropdown
                      placeholder={t("select")}
                      options={listPeriods.map((period) => ({
                        key: period,
                        text: t(period),
                        value: period,
                      }))}
                      selection
                      value={formik.values.period}
                      onChange={(_, data) => {
                        // Actualiza el valor
                        formik.setFieldValue("period", data.value);
                        // Marca el campo como tocado (opcional)
                        formik.setFieldTouched("period", true, false);
                        // Borra el error si hay uno
                        formik.setFieldError("period", undefined);
                      }}
                      error={!!formik.errors.period && !!formik.touched.period}
                      style={{ flex: 1 }}
                      name="period"
                      disabled={yearComplete}
                    />
                  </div>
                  <div
                    style={{
                      color: "red",
                      fontSize: "0.8em",
                      minHeight: "1.2em",
                    }}
                  >
                    {formik.touched.period && formik.errors.period}
                  </div>
                </div>
              </GridColumn>
            </GridRow>
          </Grid>
          {/* Mensaje de advertencia cuando el año está completo */}
          {yearComplete && !wasteForm && (
            <div
              style={{
                position: "fixed",
                top: "80px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "90%",
                maxWidth: "800px",
                zIndex: 99999,
                backgroundColor: "#fffef5",
                border: "1px solid #e8e8e8",
                borderRadius: "6px",
                padding: "15px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                textAlign: "center"
              }}
            >
              <div style={{ fontSize: "1.1em", fontWeight: "600", color: "#666", marginBottom: "8px" }}>
                Meses del año completo
              </div>
              <p style={{ fontSize: "0.95em", margin: "0", color: "#555", lineHeight: "1.5" }}>
                Todos los periodos del año <strong>{formik.values.year}</strong> ya están cargados.
                <br />
                Por favor, seleccione otro año para crear un nuevo formulario.
                <br />
                Si desea editar un periodo existente, cierre esta ventana y seleccione el formulario a editar.
              </p>
            </div>
          )}
        </>
      ) : null}
      {/* Botón para habilitar edición de unidades (solo admin/master en modo edición) */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
        {canEditUnits && wasteForm ? (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Button
              type="button"
              color={unitEditEnabled ? "orange" : "grey"}
              size="small"
              icon
              labelPosition="left"
              onClick={() => setUnitEditEnabled(!unitEditEnabled)}
            >
              <Icon name={unitEditEnabled ? "unlock" : "lock"} />
              {unitEditEnabled
                ? (t("disable_unit_edit") || "Deshabilitar edición de unidades")
                : (t("enable_unit_edit") || "Habilitar edición de unidades")
              }
            </Button>
            {unitEditEnabled && (
              <Message warning size="tiny" style={{ margin: 0, padding: "8px 12px" }}>
                <Icon name="warning sign" />
                {t("unit_edit_warning") || "Los cambios de unidad se registrarán en auditoría"}
              </Message>
            )}
          </div>
        ) : <div />}
        <Popup
          content={t("read_waste_document_tooltip") || "Leer documento de residuos"}
          trigger={
            <Form.Button
              type="button"
              color="teal"
              size="small"
              icon="file alternate"
              loading={invoiceLoading}
              onClick={() => setShowUploadModal(true)}
            />
          }
        />
      </div>
      <Table className="waste-form-table" unstackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width="1">{t("code")}</Table.HeaderCell>
            <Table.HeaderCell width="4">{t("concept")}</Table.HeaderCell>
            <Table.HeaderCell width="2">{t("value")}</Table.HeaderCell>
            <Table.HeaderCell width="2">{t("unit")}</Table.HeaderCell>
            <Table.HeaderCell width="2">{t("disposalMethod")}</Table.HeaderCell>
            <Table.HeaderCell width="2">{t("state")}</Table.HeaderCell>
            <Table.HeaderCell>{t("actions")}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row className="waste-form-section-header">
            <Table.Cell colSpan={7}>{t("non_hazardous_waste")}</Table.Cell>
          </Table.Row>
          {findActiveFieldByName("paper_and_cardboard") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.paper_and_cardboard.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("paper_and_cardboard")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="paper_and_cardboard.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  // onFocus={handleFocusNumberInput}
                  value={formik.values.paper_and_cardboard.value}
                  error={formik.errors.paper_and_cardboard?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.paper_and_cardboard?.unit &&
                    formik.touched.paper_and_cardboard?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.paper_and_cardboard.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("paper_and_cardboard").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: t(ds.name),
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "paper_and_cardboard.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "paper_and_cardboard.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "paper_and_cardboard.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.paper_and_cardboard.unit}
                    error={
                      !!formik.errors.paper_and_cardboard?.unit &&
                      !!formik.touched.paper_and_cardboard?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.paper_and_cardboard?.unit &&
                        formik.touched.paper_and_cardboard?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="paper_and_cardboard.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "paper_and_cardboard.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.paper_and_cardboard.disposalMethod}
                  error={formik.errors.paper_and_cardboard?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "paper_and_cardboard.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.paper_and_cardboard.approvalStatus}
                  error={formik.errors.paper_and_cardboard?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.paper_and_cardboard.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.paper_and_cardboard.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("paper_and_cardboard"),
                          "paper_and_cardboard"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"paper_and_cardboard"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("plastic") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.plastic.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("plastic")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="plastic.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.plastic.value}
                  error={formik.errors.plastic?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.plastic?.unit &&
                    formik.touched.plastic?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.plastic.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("plastic").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("plastic.unit", data.value);
                      formik.setFieldTouched("plastic.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("plastic.unit", undefined);
                      }
                    }}
                    value={formik.values.plastic.unit}
                    error={
                      !!formik.errors.plastic?.unit &&
                      !!formik.touched.plastic?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.plastic?.unit &&
                        formik.touched.plastic?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="plastic.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("plastic.disposalMethod", data.value)
                  }
                  value={formik.values.plastic.disposalMethod}
                  error={formik.errors.plastic?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("plastic.approvalStatus", data.value)
                  }
                  value={formik.values.plastic.approvalStatus}
                  error={formik.errors.plastic?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.plastic.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.plastic.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("plastic"), "plastic");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"plastic"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("fabric_scraps") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.fabric_scraps.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("fabric_scraps")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="fabric_scraps.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.fabric_scraps.value}
                  error={formik.errors.fabric_scraps?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.fabric_scraps?.unit &&
                    formik.touched.fabric_scraps?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.fabric_scraps.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("fabric_scraps").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("fabric_scraps.unit", data.value);
                      formik.setFieldTouched("fabric_scraps.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("fabric_scraps.unit", undefined);
                      }
                    }}
                    value={formik.values.fabric_scraps.unit}
                    error={
                      !!formik.errors.fabric_scraps?.unit &&
                      !!formik.touched.fabric_scraps?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.fabric_scraps?.unit &&
                        formik.touched.fabric_scraps?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="fabric_scraps.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "fabric_scraps.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.fabric_scraps.disposalMethod}
                  error={formik.errors.fabric_scraps?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "fabric_scraps.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.fabric_scraps.approvalStatus}
                  error={formik.errors.fabric_scraps?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.fabric_scraps.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.fabric_scraps.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("fabric_scraps"), "fabric_scraps");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"fabric_scraps"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("metal_clean") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.metal_clean.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("metal_clean")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="metal_clean.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.metal_clean.value}
                  error={formik.errors.metal_clean?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.metal_clean?.unit &&
                    formik.touched.metal_clean?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.metal_clean.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("metal_clean").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("metal_clean.unit", data.value);
                      formik.setFieldTouched("metal_clean.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("metal_clean.unit", undefined);
                      }
                    }}
                    value={formik.values.metal_clean.unit}
                    error={
                      !!formik.errors.metal_clean?.unit &&
                      !!formik.touched.metal_clean?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.metal_clean?.unit &&
                        formik.touched.metal_clean?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="metal_clean.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "metal_clean.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.metal_clean.disposalMethod}
                  error={formik.errors.metal_clean?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "metal_clean.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.metal_clean.approvalStatus}
                  error={formik.errors.metal_clean?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.metal_clean.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.metal_clean.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("metal_clean"), "metal_clean");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"metal_clean"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("wood") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.wood.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("wood")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="wood.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.wood.value}
                  error={formik.errors.wood?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.wood?.unit && formik.touched.wood?.unit && (
                    <div style={{ color: "red", fontSize: "0.8em" }}>
                      {formik.errors.wood.unit}
                    </div>
                  )}
                  <Form.Dropdown
                    options={determineWasteUnits("wood").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("wood.unit", data.value);
                      formik.setFieldTouched("wood.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("wood.unit", undefined);
                      }
                    }}
                    value={formik.values.wood.unit}
                    error={
                      !!formik.errors.wood?.unit && !!formik.touched.wood?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.wood?.unit && formik.touched.wood?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="wood.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("wood.disposalMethod", data.value)
                  }
                  value={formik.values.wood.disposalMethod}
                  error={formik.errors.wood?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("wood.approvalStatus", data.value)
                  }
                  value={formik.values.wood.approvalStatus}
                  error={formik.errors.wood?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.wood.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.wood.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("wood"), "wood");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"wood"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("food_waste") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.food_waste.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("food_waste")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="food_waste.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.food_waste.value}
                  error={formik.errors.food_waste?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.food_waste?.unit &&
                    formik.touched.food_waste?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.food_waste.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("food_waste").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("food_waste.unit", data.value);
                      formik.setFieldTouched("food_waste.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("food_waste.unit", undefined);
                      }
                    }}
                    value={formik.values.food_waste.unit}
                    error={
                      !!formik.errors.food_waste?.unit &&
                      !!formik.touched.food_waste?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.food_waste?.unit &&
                        formik.touched.food_waste?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="food_waste.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "food_waste.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.food_waste.disposalMethod}
                  error={formik.errors.food_waste?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "food_waste.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.food_waste.approvalStatus}
                  error={formik.errors.food_waste?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.food_waste.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.food_waste.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("food_waste"), "food_waste");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"food_waste"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("general_trash") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.general_trash.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("general_trash")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="general_trash.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.general_trash.value}
                  error={formik.errors.general_trash?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.general_trash?.unit &&
                    formik.touched.general_trash?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.general_trash.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("general_trash").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("general_trash.unit", data.value);
                      formik.setFieldTouched("general_trash.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("general_trash.unit", undefined);
                      }
                    }}
                    value={formik.values.general_trash.unit}
                    error={
                      !!formik.errors.general_trash?.unit &&
                      !!formik.touched.general_trash?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.general_trash?.unit &&
                        formik.touched.general_trash?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="general_trash.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "general_trash.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.general_trash.disposalMethod}
                  error={formik.errors.general_trash?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "general_trash.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.general_trash.approvalStatus}
                  error={formik.errors.general_trash?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.general_trash.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.food_waste.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("general_trash"), "general_trash");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"general_trash"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("glass") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.glass.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("glass")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="glass.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.glass.value}
                  error={formik.errors.glass?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.glass?.unit && formik.touched.glass?.unit && (
                    <div style={{ color: "red", fontSize: "0.8em" }}>
                      {formik.errors.glass.unit}
                    </div>
                  )}
                  <Form.Dropdown
                    options={determineWasteUnits("glass").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("glass.unit", data.value);
                      formik.setFieldTouched("glass.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("glass.unit", undefined);
                      }
                    }}
                    value={formik.values.glass.unit}
                    error={
                      !!formik.errors.glass?.unit &&
                      !!formik.touched.glass?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.glass?.unit && formik.touched.glass?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="glass.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("glass.disposalMethod", data.value)
                  }
                  value={formik.values.glass.disposalMethod}
                  error={formik.errors.glass?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("glass.approvalStatus", data.value)
                  }
                  value={formik.values.glass.approvalStatus}
                  error={formik.errors.glass?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.glass.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.glass.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("glass"), "glass");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"glass"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("leather") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.leather.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("leather")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="leather.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.leather.value}
                  error={formik.errors.leather?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.leather?.unit &&
                    formik.touched.leather?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.leather.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("leather").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("leather.unit", data.value);
                      formik.setFieldTouched("leather.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("leather.unit", undefined);
                      }
                    }}
                    value={formik.values.leather.unit}
                    error={
                      !!formik.errors.leather?.unit &&
                      !!formik.touched.leather?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.leather?.unit &&
                        formik.touched.leather?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="leather.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("leather.disposalMethod", data.value)
                  }
                  value={formik.values.leather.disposalMethod}
                  error={formik.errors.leather?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("leather.approvalStatus", data.value)
                  }
                  value={formik.values.leather.approvalStatus}
                  error={formik.errors.leather?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.leather.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.leather.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("leather"), "leather");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"leather"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("foam_eva") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.foam_eva.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("foam_eva")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="foam_eva.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.foam_eva.value}
                  error={formik.errors.foam_eva?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.foam_eva?.unit &&
                    formik.touched.foam_eva?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.foam_eva.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("foam_eva").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("foam_eva.unit", data.value);
                      formik.setFieldTouched("foam_eva.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("foam_eva.unit", undefined);
                      }
                    }}
                    value={formik.values.foam_eva.unit}
                    error={
                      !!formik.errors.foam_eva?.unit &&
                      !!formik.touched.foam_eva?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.foam_eva?.unit &&
                        formik.touched.foam_eva?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="foam_eva.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("foam_eva.disposalMethod", data.value)
                  }
                  value={formik.values.foam_eva.disposalMethod}
                  error={formik.errors.foam_eva?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("foam_eva.approvalStatus", data.value)
                  }
                  value={formik.values.foam_eva.approvalStatus}
                  error={formik.errors.foam_eva?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.foam_eva.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.foam_eva.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("foam_eva"), "foam_eva");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"foam_eva"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("empty_cans_or_containers") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.empty_cans_or_containers.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("empty_cans_or_containers")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="empty_cans_or_containers.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.empty_cans_or_containers.value}
                  error={formik.errors.empty_cans_or_containers?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.empty_cans_or_containers?.unit &&
                    formik.touched.empty_cans_or_containers?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.empty_cans_or_containers.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits(
                      "empty_cans_or_containers"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "empty_cans_or_containers.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "empty_cans_or_containers.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "empty_cans_or_containers.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.empty_cans_or_containers.unit}
                    error={
                      !!formik.errors.empty_cans_or_containers?.unit &&
                      !!formik.touched.empty_cans_or_containers?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.empty_cans_or_containers?.unit &&
                        formik.touched.empty_cans_or_containers?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="empty_cans_or_containers.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "empty_cans_or_containers.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.empty_cans_or_containers.disposalMethod}
                  error={formik.errors.empty_cans_or_containers?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "empty_cans_or_containers.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.empty_cans_or_containers.approvalStatus}
                  error={formik.errors.empty_cans_or_containers?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.empty_cans_or_containers.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.empty_cans_or_containers.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("empty_cans_or_containers"),
                          "empty_cans_or_containers"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"empty_cans_or_containers"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("rubber") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.rubber.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("rubber")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="rubber.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.rubber.value}
                  error={formik.errors.rubber?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.rubber?.unit &&
                    formik.touched.rubber?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.rubber.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("rubber").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("rubber.unit", data.value);
                      formik.setFieldTouched("rubber.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("rubber.unit", undefined);
                      }
                    }}
                    value={formik.values.rubber.unit}
                    error={
                      !!formik.errors.rubber?.unit &&
                      !!formik.touched.rubber?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.rubber?.unit &&
                        formik.touched.rubber?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="rubber.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("rubber.disposalMethod", data.value)
                  }
                  value={formik.values.rubber.disposalMethod}
                  error={formik.errors.rubber?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("rubber.approvalStatus", data.value)
                  }
                  value={formik.values.rubber.approvalStatus}
                  error={formik.errors.rubber?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.rubber.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.rubber.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("rubber"), "rubber");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"rubber"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("other_non_hazardous_waste") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.other_non_hazardous_waste.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("other_non_hazardous_waste")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="other_non_hazardous_waste.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.other_non_hazardous_waste.value}
                  error={formik.errors.other_non_hazardous_waste?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.other_non_hazardous_waste?.unit &&
                    formik.touched.other_non_hazardous_waste?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.other_non_hazardous_waste.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits(
                      "other_non_hazardous_waste"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "other_non_hazardous_waste.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "other_non_hazardous_waste.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "other_non_hazardous_waste.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.other_non_hazardous_waste.unit}
                    error={
                      !!formik.errors.other_non_hazardous_waste?.unit &&
                      !!formik.touched.other_non_hazardous_waste?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.other_non_hazardous_waste?.unit &&
                        formik.touched.other_non_hazardous_waste?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="other_non_hazardous_waste.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "other_non_hazardous_waste.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.other_non_hazardous_waste.disposalMethod}
                  error={
                    formik.errors.other_non_hazardous_waste?.disposalMethod
                  }
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "other_non_hazardous_waste.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.other_non_hazardous_waste.approvalStatus}
                  error={
                    formik.errors.other_non_hazardous_waste?.approvalStatus
                  }
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.other_non_hazardous_waste.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.other_non_hazardous_waste.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("other_non_hazardous_waste"),
                          "other_non_hazardous_waste"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"other_non_hazardous_waste"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          <Table.Row className="waste-form-section-header">
            <Table.Cell colSpan={7}>{t("hazardous_waste")}</Table.Cell>
          </Table.Row>
          {findActiveFieldByName("electronic_waste") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.electronic_waste.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("electronic_waste")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="electronic_waste.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.electronic_waste.value}
                  error={formik.errors.electronic_waste?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.electronic_waste?.unit &&
                    formik.touched.electronic_waste?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.electronic_waste.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("electronic_waste").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: t(ds.name),
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("electronic_waste.unit", data.value);
                      formik.setFieldTouched(
                        "electronic_waste.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "electronic_waste.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.electronic_waste.unit}
                    error={
                      !!formik.errors.electronic_waste?.unit &&
                      !!formik.touched.electronic_waste?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.electronic_waste?.unit &&
                        formik.touched.electronic_waste?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="electronic_waste.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "electronic_waste.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.electronic_waste.disposalMethod}
                  error={formik.errors.electronic_waste?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "electronic_waste.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.electronic_waste.approvalStatus}
                  error={formik.errors.electronic_waste?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.electronic_waste.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.electronic_waste.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("electronic_waste"),
                          "electronic_waste"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"electronic_waste"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("empty_chemical_containers") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.empty_chemical_containers.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("empty_chemical_containers")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="empty_chemical_containers.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.empty_chemical_containers.value}
                  error={formik.errors.empty_chemical_containers?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.empty_chemical_containers?.unit &&
                    formik.touched.empty_chemical_containers?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.empty_chemical_containers.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits(
                      "empty_chemical_containers"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "empty_chemical_containers.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "empty_chemical_containers.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "empty_chemical_containers.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.empty_chemical_containers.unit}
                    error={
                      !!formik.errors.empty_chemical_containers?.unit &&
                      !!formik.touched.empty_chemical_containers?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.empty_chemical_containers?.unit &&
                        formik.touched.empty_chemical_containers?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="empty_chemical_containers.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "empty_chemical_containers.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.empty_chemical_containers.disposalMethod}
                  error={
                    formik.errors.empty_chemical_containers?.disposalMethod
                  }
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "empty_chemical_containers.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.empty_chemical_containers.approvalStatus}
                  error={
                    formik.errors.empty_chemical_containers?.approvalStatus
                  }
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.empty_chemical_containers.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.empty_chemical_containers.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("empty_chemical_containers"),
                          "empty_chemical_containers"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"empty_chemical_containers"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("cleaning_pesticide_containers") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.cleaning_pesticide_containers.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("cleaning_pesticide_containers")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="cleaning_pesticide_containers.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.cleaning_pesticide_containers.value}
                  error={formik.errors.cleaning_pesticide_containers?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.cleaning_pesticide_containers?.unit &&
                    formik.touched.cleaning_pesticide_containers?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.cleaning_pesticide_containers.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits(
                      "cleaning_pesticide_containers"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "cleaning_pesticide_containers.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "cleaning_pesticide_containers.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "cleaning_pesticide_containers.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.cleaning_pesticide_containers.unit}
                    error={
                      !!formik.errors.cleaning_pesticide_containers?.unit &&
                      !!formik.touched.cleaning_pesticide_containers?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.cleaning_pesticide_containers?.unit &&
                        formik.touched.cleaning_pesticide_containers?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="cleaning_pesticide_containers.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "cleaning_pesticide_containers.disposalMethod",
                      data.value
                    )
                  }
                  value={
                    formik.values.cleaning_pesticide_containers.disposalMethod
                  }
                  error={
                    formik.errors.cleaning_pesticide_containers?.disposalMethod
                  }
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "cleaning_pesticide_containers.approvalStatus",
                      data.value
                    )
                  }
                  value={
                    formik.values.cleaning_pesticide_containers.approvalStatus
                  }
                  error={
                    formik.errors.cleaning_pesticide_containers?.approvalStatus
                  }
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.cleaning_pesticide_containers.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.cleaning_pesticide_containers.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("cleaning_pesticide_containers"),
                          "cleaning_pesticide_containers"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"cleaning_pesticide_containers"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("batteries") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.batteries.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("batteries")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="batteries.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.batteries.value}
                  error={formik.errors.batteries?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.batteries?.unit &&
                    formik.touched.batteries?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.batteries.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("batteries").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("batteries.unit", data.value);
                      formik.setFieldTouched("batteries.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("batteries.unit", undefined);
                      }
                    }}
                    value={formik.values.batteries.unit}
                    error={
                      !!formik.errors.batteries?.unit &&
                      !!formik.touched.batteries?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.batteries?.unit &&
                        formik.touched.batteries?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="batteries.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("batteries.disposalMethod", data.value)
                  }
                  value={formik.values.batteries.disposalMethod}
                  error={formik.errors.batteries?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("batteries.approvalStatus", data.value)
                  }
                  value={formik.values.batteries.approvalStatus}
                  error={formik.errors.batteries?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.batteries.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.batteries.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("batteries"), "batteries");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"batteries"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("fluorescent_tubes") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.fluorescent_tubes.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("fluorescent_tubes")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="fluorescent_tubes.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.fluorescent_tubes.value}
                  error={formik.errors.fluorescent_tubes?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.fluorescent_tubes?.unit &&
                    formik.touched.fluorescent_tubes?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.fluorescent_tubes.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("fluorescent_tubes").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: t(ds.name),
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "fluorescent_tubes.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "fluorescent_tubes.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "fluorescent_tubes.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.fluorescent_tubes.unit}
                    error={
                      !!formik.errors.fluorescent_tubes?.unit &&
                      !!formik.touched.fluorescent_tubes?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.fluorescent_tubes?.unit &&
                        formik.touched.fluorescent_tubes?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="fluorescent_tubes.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "fluorescent_tubes.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.fluorescent_tubes.disposalMethod}
                  error={formik.errors.fluorescent_tubes?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "fluorescent_tubes.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.fluorescent_tubes.approvalStatus}
                  error={formik.errors.fluorescent_tubes?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.fluorescent_tubes.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.fluorescent_tubes.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("fluorescent_tubes"),
                          "fluorescent_tubes"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"fluorescent_tubes"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("cooking_oil") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.cooking_oil.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("cooking_oil")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="cooking_oil.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.cooking_oil.value}
                  error={formik.errors.cooking_oil?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.cooking_oil?.unit &&
                    formik.touched.cooking_oil?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.cooking_oil.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("cooking_oil").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("cooking_oil.unit", data.value);
                      formik.setFieldTouched("cooking_oil.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("cooking_oil.unit", undefined);
                      }
                    }}
                    value={formik.values.cooking_oil.unit}
                    error={
                      !!formik.errors.cooking_oil?.unit &&
                      !!formik.touched.cooking_oil?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.cooking_oil?.unit &&
                        formik.touched.cooking_oil?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="cooking_oil.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "cooking_oil.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.cooking_oil.disposalMethod}
                  error={formik.errors.cooking_oil?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "cooking_oil.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.cooking_oil.approvalStatus}
                  error={formik.errors.cooking_oil?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.cooking_oil.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.cooking_oil.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("cooking_oil"), "cooking_oil");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"cooking_oil"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("maintenance_oil") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.maintenance_oil.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("maintenance_oil")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="maintenance_oil.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.maintenance_oil.value}
                  error={formik.errors.maintenance_oil?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.maintenance_oil?.unit &&
                    formik.touched.maintenance_oil?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.maintenance_oil.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("maintenance_oil").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: t(ds.name),
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("maintenance_oil.unit", data.value);
                      formik.setFieldTouched(
                        "maintenance_oil.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError("maintenance_oil.unit", undefined);
                      }
                    }}
                    value={formik.values.maintenance_oil.unit}
                    error={
                      !!formik.errors.maintenance_oil?.unit &&
                      !!formik.touched.maintenance_oil?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.maintenance_oil?.unit &&
                        formik.touched.maintenance_oil?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="maintenance_oil.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "maintenance_oil.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.maintenance_oil.disposalMethod}
                  error={formik.errors.maintenance_oil?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "maintenance_oil.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.maintenance_oil.approvalStatus}
                  error={formik.errors.maintenance_oil?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.maintenance_oil.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.maintenance_oil.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("maintenance_oil"), "maintenance_oil");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"maintenance_oil"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("lubricants") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.lubricants.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("lubricants")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="lubricants.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.lubricants.value}
                  error={formik.errors.lubricants?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.lubricants?.unit &&
                    formik.touched.lubricants?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.lubricants.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("lubricants").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("lubricants.unit", data.value);
                      formik.setFieldTouched("lubricants.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("lubricants.unit", undefined);
                      }
                    }}
                    value={formik.values.lubricants.unit}
                    error={
                      !!formik.errors.lubricants?.unit &&
                      !!formik.touched.lubricants?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.lubricants?.unit &&
                        formik.touched.lubricants?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="lubricants.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "lubricants.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.lubricants.disposalMethod}
                  error={formik.errors.lubricants?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "lubricants.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.lubricants.approvalStatus}
                  error={formik.errors.lubricants?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.lubricants.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.lubricants.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("lubricants"), "lubricants");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"lubricants"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("paint_waste") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.paint_waste.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("paint_waste")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="paint_waste.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.paint_waste.value}
                  error={formik.errors.paint_waste?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.paint_waste?.unit &&
                    formik.touched.paint_waste?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.paint_waste.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("paint_waste").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("paint_waste.unit", data.value);
                      formik.setFieldTouched("paint_waste.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("paint_waste.unit", undefined);
                      }
                    }}
                    value={formik.values.paint_waste.unit}
                    error={
                      !!formik.errors.paint_waste?.unit &&
                      !!formik.touched.paint_waste?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.paint_waste?.unit &&
                        formik.touched.paint_waste?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="paint_waste.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "paint_waste.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.paint_waste.disposalMethod}
                  error={formik.errors.paint_waste?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "paint_waste.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.paint_waste.approvalStatus}
                  error={formik.errors.paint_waste?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.paint_waste.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.paint_waste.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("paint_waste"), "paint_waste");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"paint_waste"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("coal_ashes") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.coal_ashes.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("coal_ashes")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="coal_ashes.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.coal_ashes.value}
                  error={formik.errors.coal_ashes?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.coal_ashes?.unit &&
                    formik.touched.coal_ashes?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.coal_ashes.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("coal_ashes").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("coal_ashes.unit", data.value);
                      formik.setFieldTouched("coal_ashes.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("coal_ashes.unit", undefined);
                      }
                    }}
                    value={formik.values.coal_ashes.unit}
                    error={
                      !!formik.errors.coal_ashes?.unit &&
                      !!formik.touched.coal_ashes?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.coal_ashes?.unit &&
                        formik.touched.coal_ashes?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="coal_ashes.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "coal_ashes.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.coal_ashes.disposalMethod}
                  error={formik.errors.coal_ashes?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "coal_ashes.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.coal_ashes.approvalStatus}
                  error={formik.errors.coal_ashes?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.coal_ashes.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.coal_ashes.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("coal_ashes"), "coal_ashes");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"coal_ashes"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("rubber_hazardous") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.rubber_hazardous.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("rubber_hazardous")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="rubber_hazardous.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.rubber_hazardous.value}
                  error={formik.errors.rubber_hazardous?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.rubber_hazardous?.unit &&
                    formik.touched.rubber_hazardous?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.rubber_hazardous.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("rubber_hazardous").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: t(ds.name),
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("rubber_hazardous.unit", data.value);
                      formik.setFieldTouched(
                        "rubber_hazardous.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "rubber_hazardous.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.rubber_hazardous.unit}
                    error={
                      !!formik.errors.rubber_hazardous?.unit &&
                      !!formik.touched.rubber_hazardous?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.rubber_hazardous?.unit &&
                        formik.touched.rubber_hazardous?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="rubber_hazardous.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "rubber_hazardous.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.rubber_hazardous.disposalMethod}
                  error={formik.errors.rubber_hazardous?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "rubber_hazardous.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.rubber_hazardous.approvalStatus}
                  error={formik.errors.rubber_hazardous?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.rubber_hazardous.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.rubber_hazardous.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("rubber_hazardous"),
                          "rubber_hazardous"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"rubber_hazardous"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("chemicals") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.chemicals.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("chemicals")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="chemicals.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.chemicals.value}
                  error={formik.errors.chemicals?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.chemicals?.unit &&
                    formik.touched.chemicals?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.chemicals.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("chemicals").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("chemicals.unit", data.value);
                      formik.setFieldTouched("chemicals.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("chemicals.unit", undefined);
                      }
                    }}
                    value={formik.values.chemicals.unit}
                    error={
                      !!formik.errors.chemicals?.unit &&
                      !!formik.touched.chemicals?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.chemicals?.unit &&
                        formik.touched.chemicals?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="chemicals.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("chemicals.disposalMethod", data.value)
                  }
                  value={formik.values.chemicals.disposalMethod}
                  error={formik.errors.chemicals?.disposalMethod}
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("chemicals.approvalStatus", data.value)
                  }
                  value={formik.values.chemicals.approvalStatus}
                  error={formik.errors.chemicals?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.chemicals.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.chemicals.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("chemicals"), "chemicals");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />

                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"chemicals"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("contaminated_materials") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.contaminated_materials.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("contaminated_materials")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="contaminated_materials.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.contaminated_materials.value}
                  error={formik.errors.contaminated_materials?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.contaminated_materials?.unit &&
                    formik.touched.contaminated_materials?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.contaminated_materials.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("contaminated_materials").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: t(ds.name),
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "contaminated_materials.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "contaminated_materials.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "contaminated_materials.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.contaminated_materials.unit}
                    error={
                      !!formik.errors.contaminated_materials?.unit &&
                      !!formik.touched.contaminated_materials?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.contaminated_materials?.unit &&
                        formik.touched.contaminated_materials?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="contaminated_materials.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "contaminated_materials.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.contaminated_materials.disposalMethod}
                  error={formik.errors.contaminated_materials?.disposalMethod}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "contaminated_materials.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.contaminated_materials.approvalStatus}
                  error={formik.errors.contaminated_materials?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.contaminated_materials.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.contaminated_materials.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("contaminated_materials"),
                          "contaminated_materials"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />

                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"contaminated_materials"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("ink_cartridges") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.ink_cartridges.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("ink_cartridges")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="ink_cartridges.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.ink_cartridges.value}
                  error={formik.errors.ink_cartridges?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.ink_cartridges?.unit &&
                    formik.touched.ink_cartridges?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.ink_cartridges.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("ink_cartridges").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("ink_cartridges.unit", data.value);
                      formik.setFieldTouched(
                        "ink_cartridges.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError("ink_cartridges.unit", undefined);
                      }
                    }}
                    value={formik.values.ink_cartridges.unit}
                    error={
                      !!formik.errors.ink_cartridges?.unit &&
                      !!formik.touched.ink_cartridges?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.ink_cartridges?.unit &&
                        formik.touched.ink_cartridges?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="ink_cartridges.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "ink_cartridges.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.ink_cartridges.disposalMethod}
                  error={formik.errors.ink_cartridges?.disposalMethod}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "ink_cartridges.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.ink_cartridges.approvalStatus}
                  error={formik.errors.ink_cartridges?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.ink_cartridges.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.ink_cartridges.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("ink_cartridges"), "ink_cartridges");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />

                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"ink_cartridges"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("medical_waste") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.medical_waste.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("medical_waste")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="medical_waste.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.medical_waste.value}
                  error={formik.errors.medical_waste?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.medical_waste?.unit &&
                    formik.touched.medical_waste?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.medical_waste.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("medical_waste").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("medical_waste.unit", data.value);
                      formik.setFieldTouched("medical_waste.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("medical_waste.unit", undefined);
                      }
                    }}
                    value={formik.values.medical_waste.unit}
                    error={
                      !!formik.errors.medical_waste?.unit &&
                      !!formik.touched.medical_waste?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.medical_waste?.unit &&
                        formik.touched.medical_waste?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="medical_waste.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "medical_waste.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.medical_waste.disposalMethod}
                  error={formik.errors.medical_waste?.disposalMethod}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "medical_waste.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.medical_waste.approvalStatus}
                  error={formik.errors.medical_waste?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.medical_waste.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.medical_waste.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("medical_waste"), "medical_waste");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />

                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"medical_waste"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("other_hazardous_waste") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.other_hazardous_waste.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("other_hazardous_waste")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="other_hazardous_waste.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.other_hazardous_waste.value}
                  error={formik.errors.other_hazardous_waste?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.other_hazardous_waste?.unit &&
                    formik.touched.other_hazardous_waste?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.other_hazardous_waste.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWasteUnits("other_hazardous_waste").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: t(ds.name),
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "other_hazardous_waste.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "other_hazardous_waste.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "other_hazardous_waste.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.other_hazardous_waste.unit}
                    error={
                      !!formik.errors.other_hazardous_waste?.unit &&
                      !!formik.touched.other_hazardous_waste?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.other_hazardous_waste?.unit &&
                        formik.touched.other_hazardous_waste?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="other_hazardous_waste.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  options={disposalMethods.map((ds) => {
                    return {
                      key: ds,
                      text: t(ds),
                      value: ds,
                    };
                  })}
                  selection
                  disabled={wasteForm && !isMaster(user.role) && !isAdmin(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "other_hazardous_waste.disposalMethod",
                      data.value
                    )
                  }
                  value={formik.values.other_hazardous_waste.disposalMethod}
                  error={formik.errors.other_hazardous_waste?.disposalMethod}
                />
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "other_hazardous_waste.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.other_hazardous_waste.approvalStatus}
                  error={formik.errors.other_hazardous_waste?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.other_hazardous_waste.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.other_hazardous_waste.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("other_hazardous_waste"),
                          "other_hazardous_waste"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />

                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"other_hazardous_waste"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
        </Table.Body>
      </Table>

      <ToastContainer
        position="bottom-center"
        autoClose={1200}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <BasicModal
        show={showModal}
        onClose={() => setShowModal(false)} // cerrar desde aquí
        title={titleModal}
        size="tiny"
        closeOnDimmerClick={false} // evita cierre al hacer clic fuera
        closeOnEscape={false} // opcional
      >
        <div onClick={(e) => e.stopPropagation()}>
          <Comments
            formik={formik}
            fieldName={fieldName}
            onClose={() => setShowModal(false)}
            onReload={onReload}
            wasteForm={wasteForm}
            user={user}
            t={t}
          />
        </div>
      </BasicModal>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "0.5rem",
          marginRight: 20,
          marginTop: 20,
          alignItems: "center",
        }}
      >
        <Button
          type="submit"
          primary
          size="large"
          loading={formik.isSubmitting}
          content={!wasteForm ? t("save") : t("update")}
        />

        <Button
          type="button"
          color="red"
          secondary
          size="large"
          onClick={() => {
            onClose ? onClose() : goBack();
          }}
        >
          {t("cancel")}
        </Button>
      </div>

      {/* Modal de carga de documento de residuos */}
      <Modal open={showUploadModal} onClose={() => !invoiceLoading && setShowUploadModal(false)} size="small" closeOnDimmerClick={!invoiceLoading} className="invoice-reader-modal">
        <Modal.Header><Icon name="file alternate outline" /> {t("read_waste_document_tooltip") || "Leer documento de residuos"}</Modal.Header>
        <Modal.Content>
          <InvoiceDropzone onFiles={processInvoiceFiles} loading={invoiceLoading} t={t} inputRef={invoiceInputRef} onInputChange={handleInvoiceFileChange} />
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={() => setShowUploadModal(false)} disabled={invoiceLoading}>{t("cancel")}</Button>
        </Modal.Actions>
      </Modal>

      {/* Modal preview de datos extraídos del documento de residuos */}
      <Modal
        open={showInvoiceModal}
        onClose={() => { setShowInvoiceModal(false); setBulkSaveResults(null); }}
        size="small"
        closeOnDimmerClick={false}
        className="invoice-preview-modal"
      >
        <Modal.Header>
          <Icon name="file alternate outline" /> {t("extracted_waste_document_data") || "Datos extraídos del documento"}
        </Modal.Header>
        <Modal.Content scrolling>
          {invoiceResults.length > 0 && (() => {
            const MONTH_NAMES = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];
            const VALID_UNITS = ["g","kg","ton","L","m3"];

            // Agrupar por período+año (igual que Water modal)
            const sorted = [...invoiceResults].sort((a, b) => {
              if (a.error && !b.error) return 1;
              if (!a.error && b.error) return -1;
              const yearDiff = (b.year || 0) - (a.year || 0);
              if (yearDiff !== 0) return yearDiff;
              return (b.period || 0) - (a.period || 0);
            });
            const groups = [];
            const groupMap = new Map();
            sorted.forEach(r => {
              const key = r.error ? "__errors__" : (r.year && r.period ? `${r.year}-${r.period}` : "__unknown__");
              if (!groupMap.has(key)) {
                groupMap.set(key, { key, year: r.year, period: r.period, isError: !!r.error, isUnknown: !r.year || !r.period, rows: [] });
                groups.push(groupMap.get(key));
              }
              groupMap.get(key).rows.push(r);
            });

            return (
              <div className="invoice-reader-preview">
                <Message info size="small" style={{ marginBottom: "0.75rem" }}>
                  <Icon name="info circle" />
                  {t("review_invoice_instructions") || "Aplicá las filas que querés incluir, luego hacé clic en Guardar."}
                </Message>
                {invoiceResults.some((r) => r.needsReview) && (
                  <Message warning size="small" style={{ marginBottom: "0.75rem" }}>
                    <Icon name="warning sign" />
                    {`Se detectaron ${invoiceResults.find((r) => r.needsReview)?.pagesDetected} páginas pero solo se pudo extraer 1 comprobante. Revisá los datos con cuidado antes de guardar — puede haber varios meses mezclados en una sola fila.`}
                  </Message>
                )}
                <Table size="small" compact>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>{t("file") || "Archivo"}</Table.HeaderCell>
                      <Table.HeaderCell>{t("waste_type") || "Tipo de residuo"}</Table.HeaderCell>
                      <Table.HeaderCell>{t("waste_weight")}</Table.HeaderCell>
                      <Table.HeaderCell></Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {groups.map(group => (
                      <React.Fragment key={group.key}>
                        {/* Encabezado de período — igual al modal de Water */}
                        <Table.Row>
                          <Table.Cell
                            colSpan={4}
                            style={{ background: group.isError ? "#fff0f0" : "#f0f4f9", padding: "5px 10px", borderTop: "2px solid #d0dce8" }}
                          >
                            <Icon
                              name={group.isError ? "exclamation triangle" : "calendar alternate outline"}
                              style={{ color: group.isError ? "#c0392b" : "#648EBC" }}
                            />
                            <strong style={{ fontSize: "0.88em", color: group.isError ? "#c0392b" : "#2c5282" }}>
                              {group.isError
                                ? (t("errors") || "Errores")
                                : group.isUnknown
                                  ? (t("period_not_detected") || "Período no detectado")
                                  : `${MONTH_NAMES[(parseInt(group.period) || 1) - 1]} ${group.year}`}
                            </strong>
                            <span style={{ marginLeft: "8px", fontSize: "0.78em", color: "#888" }}>
                              ({group.rows.length} {group.rows.length === 1 ? (t("waste_type") || "tipo") : (t("waste_types") || "tipos")})
                            </span>
                          </Table.Cell>
                        </Table.Row>
                        {/* Filas de residuos del grupo */}
                        {group.rows.map((r, i) => (
                          <Table.Row key={r._rowId || i} negative={!!r.error}>
                            <Table.Cell>
                              <Icon name="paperclip" />
                              <span style={{ fontSize: "0.85em" }}>{r.filename}</span>
                              {r.format && <span style={{ marginLeft: "0.4rem", background: "#e8f4fd", color: "#1a6ba0", borderRadius: "4px", padding: "1px 6px", fontSize: "0.72rem", fontWeight: 600, textTransform: "uppercase" }}>{r.format}</span>}
                            </Table.Cell>
                            <Table.Cell>
                              {r.error ? <span style={{color:"red"}}>{r.error}</span> : (
                                <div>
                                  {r.wasteType
                                    ? <span style={{ background: "#f0f4f9", borderRadius: "4px", padding: "2px 7px", fontSize: "0.8em", fontWeight: 600 }}>{t(r.wasteType) || r.wasteType}</span>
                                    : <span style={{color:"#aaa"}}>{t("not_detected") || "No detectado"}</span>}
                                  {r.description && (
                                    <div style={{ fontSize: "0.72em", color: "#888", marginTop: "2px", maxWidth: "160px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={r.description}>
                                      {r.description}
                                    </div>
                                  )}
                                </div>
                              )}
                            </Table.Cell>
                            <Table.Cell>
                              {r.error ? "—" : r.weight != null
                                ? <span>
                                    <strong>{formatInvoiceQuantity(r.weight, language)}</strong>{" "}
                                    {r.unit
                                      ? <span style={{ fontSize: "0.82em", color: VALID_UNITS.includes(r.unit) ? "#555" : "#e67e22" }}>{r.unit}</span>
                                      : <span style={{ fontSize: "0.75em", color: "#e67e22" }}>{t("no_unit")}</span>}
                                    {r.unit && !VALID_UNITS.includes(r.unit) && (
                                      <div style={{ fontSize: "0.7em", color: "#e67e22" }}>{t("invoice_check_unit")}</div>
                                    )}
                                  </span>
                                : <span style={{color:"#aaa"}}>{t("not_detected") || "No detectado"}</span>}
                            </Table.Cell>
                            <Table.Cell>
                              {!r.error && (() => {
                                const btnStyle = { padding: "0.35em 0.75em", lineHeight: 1 };
                                if (appliedIndexes.has(r._rowId)) {
                                  return (
                                    <Button size="mini" color="green" disabled style={btnStyle}>
                                      <Icon name="check" /> {t("applied") || "Aplicado"}
                                    </Button>
                                  );
                                }
                                const hasConflict = r.wasteType && r.period && r.year && invoiceResults.some(
                                  other => other._rowId !== r._rowId &&
                                    appliedIndexes.has(other._rowId) &&
                                    other.wasteType === r.wasteType &&
                                    other.period === r.period &&
                                    other.year === r.year
                                );
                                return hasConflict
                                  ? <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "0.4em",
                                        background: "#f0f4f9",
                                        border: "1px solid #d0dce8",
                                        borderRadius: "8px",
                                        padding: "0.5em",
                                      }}
                                    >
                                      <Dropdown
                                        icon={null}
                                        placeholder={t("voucher_number") || "Nº de comprobante"}
                                        search
                                        selection
                                        allowAdditions
                                        additionLabel={`${t("add_new_voucher") || "Nuevo comprobante"}: `}
                                        options={existingVoucherNumbers.map((name) => ({ key: name, text: name, value: name }))}
                                        value={voucherNumbers[r._rowId] || ""}
                                        onAddItem={(_, d) => setExistingVoucherNumbers((prev) => [...prev, d.value].sort())}
                                        onChange={(_, d) => setVoucherNumbers(prev => ({ ...prev, [r._rowId]: d.value }))}
                                        style={{ width: "100%", fontSize: "0.8em", minHeight: "auto" }}
                                      />
                                      <Button size="mini" color="blue" style={btnStyle} onClick={() => handleApplyInvoiceData(r)}>
                                        <Icon name="plus" /> {t("add_as_voucher") || "Agregar como comprobante"}
                                      </Button>
                                    </div>
                                  : <Button size="mini" color="teal" style={btnStyle} onClick={() => handleApplyInvoiceData(r)}>
                                      <Icon name="check" /> {t("apply") || "Aplicar"}
                                    </Button>;
                              })()}
                            </Table.Cell>
                          </Table.Row>
                        ))}
                      </React.Fragment>
                    ))}
                  </Table.Body>
                </Table>
              </div>
            );
          })()}

          <div ref={bulkSaveResultsRef} />
          {bulkSaveResults && (() => {
            const renderList = (items, color) => (
              <ul style={{ margin: "4px 0 0 16px", padding: 0, listStyle: "none" }}>
                {items.map((item, i) => (
                  <li key={i} style={{ fontSize: "0.82em", color: "#555", marginBottom: 2 }}>
                    <Icon name="file alternate outline" style={{ color }} />
                    <strong>{t(item.period)} {item.year}</strong>
                    {item.count && <span style={{ marginLeft: 6, color: "#648EBC" }}>({item.count} tipos)</span>}
                    {item.filename && <span style={{ marginLeft: 6, color: "#888" }}>— {item.filename}</span>}
                    {item.msg && <span style={{ marginLeft: 6, color: "#c0392b" }}>({item.msg})</span>}
                  </li>
                ))}
              </ul>
            );
            return (
              <Message
                success={bulkSaveResults.errors.length === 0 && bulkSaveResults.saved.length > 0}
                warning={bulkSaveResults.errors.length > 0 || bulkSaveResults.saved.length === 0}
                style={{ marginTop: "1rem" }}
              >
                <Message.Header>{t("bulk_save_result") || "Resultado del guardado"}</Message.Header>
                {bulkSaveResults.saved.length > 0 && (
                  <div style={{ marginTop: "0.5rem" }}>
                    <Icon name="check circle" color="green" />
                    <strong style={{ color: "#27ae60" }}>{bulkSaveResults.saved.length} {t("bulk_saved_ok") || "guardados correctamente"}</strong>
                    {renderList(bulkSaveResults.saved, "#27ae60")}
                  </div>
                )}
                {bulkSaveResults.skipped.length > 0 && (
                  <div style={{ marginTop: "0.5rem" }}>
                    <Icon name="warning sign" color="yellow" />
                    <strong style={{ color: "#e67e22" }}>{bulkSaveResults.skipped.length} {t("bulk_skipped") || "omitidos (período ya existía)"}</strong>
                    {renderList(bulkSaveResults.skipped, "#e67e22")}
                  </div>
                )}
                {bulkSaveResults.errors.length > 0 && (
                  <div style={{ marginTop: "0.5rem" }}>
                    <Icon name="times circle" color="red" />
                    <strong style={{ color: "#c0392b" }}>{bulkSaveResults.errors.length} {t("bulk_errors") || "con error al guardar"}</strong>
                    {renderList(bulkSaveResults.errors, "#c0392b")}
                  </div>
                )}
              </Message>
            );
          })()}
        </Modal.Content>
        <Modal.Actions>
          {appliedIndexes.size > 0 && (
            <Button
              primary
              onClick={handleSaveAllInvoiceData}
              loading={bulkSaveLoading}
              disabled={bulkSaveLoading || !!bulkSaveResults}
            >
              <Icon name="save" /> {`${t("save_applied") || "Guardar"} (${appliedIndexes.size})`}
            </Button>
          )}
          <Button secondary onClick={() => { setShowInvoiceModal(false); setBulkSaveResults(null); }} disabled={bulkSaveLoading}>
            <Icon name="close" /> {t("close") || "Cerrar"}
          </Button>
        </Modal.Actions>
      </Modal>
    </Form>
  );
}

function InvoiceDropzone({ onFiles, loading, t, inputRef, onInputChange }) {
  const [isDragOver, setIsDragOver] = useState(false);
  const { getRootProps, getInputProps } = useDropzone({
    accept: { "application/pdf": [], "image/*": [], "text/csv": [], "application/vnd.ms-excel": [], "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [], "text/plain": [] },
    multiple: true, disabled: loading, noClick: true, noKeyboard: true,
    onDrop: (accepted) => { if (accepted.length > 0) onFiles(accepted); },
    onDragEnter: () => setIsDragOver(true),
    onDragLeave: () => setIsDragOver(false),
    onDropAccepted: () => setIsDragOver(false),
    onDropRejected: () => setIsDragOver(false),
  });
  return (
    <div {...getRootProps()} style={{ border: `2px dashed ${isDragOver ? "#648EBC" : "#b0c4de"}`, borderRadius: "12px", padding: "2.5rem 1.5rem", minHeight: "260px", textAlign: "center", cursor: loading ? "not-allowed" : "pointer", background: isDragOver ? "#f0f6ff" : "#fafafa", transition: "all 0.2s ease", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "1rem" }}>
      <input {...getInputProps()} />
      <input ref={inputRef} type="file" accept=".pdf,.jpg,.jpeg,.png,.webp,.csv,.xlsx,.xls,.txt" multiple style={{ display: "none" }} onChange={onInputChange} />
      {loading ? (
        <><img src={`${process.env.PUBLIC_URL}/favicon.png`} alt="sustemia" className="invoice-dropzone-spinner" /><p style={{ color: "#648EBC", fontWeight: 600 }}>{t("processing")}</p></>
      ) : (
        <><Icon name="cloud upload" size="huge" color="blue" style={{ margin: 0 }} />
          <p style={{ margin: 0, fontSize: "1rem", fontWeight: 500, color: "#333" }}>{t("drag_drop_files")}</p>
          <p style={{ margin: 0, color: "#888", fontSize: "0.85rem" }}>o</p>
          <Button type="button" primary onClick={(e) => { e.stopPropagation(); inputRef.current?.click(); }}><Icon name="folder open outline" />{t("select_files")}</Button>
          <p style={{ margin: 0, color: "#aaa", fontSize: "0.75rem" }}>{t("supported_formats")}</p>
        </>
      )}
    </div>
  );
}

function Comments({ formik, user, fieldName, onClose, t }) {
  const [comment, setComment] = useState("");

  const handleAddComment = () => {
    if (comment.trim().length > 0) {
      const reviews = [...(formik.values[fieldName].reviews || [])];

      reviews.push({
        comments: comment.trim(),
        date: new Date(),
        reviewer_user: user ? user._id : null,
      });

      formik.setFieldValue(`${fieldName}.reviews`, reviews);
      setComment("");
    }
  };

  const handleSaveComment = (id, editedContent) => {
    const reviews = [...formik.values[fieldName].reviews];
    reviews[id] = {
      ...reviews[id],
      comments: editedContent.trim(),
      date: new Date(),
    };
    formik.setFieldValue(`${fieldName}.reviews`, reviews);
  };

  const reviews = formik.values[fieldName]?.reviews || [];

  return (
    <CommentGroup minimal>
      <Header as="h4" dividing>{t("comments")}</Header>
      {reviews.map((review, index) => (
        <React.Fragment key={index}>
          <EditableComment
            id={index}
            author={
              review.reviewer_user
                ? review.reviewer_user === user._id
                  ? `${user.firstname} ${user.lastname}`
                  : `${review.reviewer_user.firstname} ${review.reviewer_user.lastname}`
                : ""
            }
            date={formatDateHourCompleted(review.date)}
            content={review.comments}
            onSave={handleSaveComment}
            active={review.reviewer_user === user._id}
            t={t}
          />
          <Divider fitted /> {console.log(review)}
        </React.Fragment>
      ))}


      {/* ✨ Form con preventDefault para evitar submit accidental */}
      <Form reply className="comments-reply-form" onSubmit={(e) => e.preventDefault()}>
        <Form.TextArea
          placeholder={t("write_a_comment")}
          rows={3}
          style={{ minHeight: 100 }}
          onChange={(_, data) => setComment(data.value)}
          value={comment}
        />

        <div
          style={{
            display: "flex",
            gap: "1em",
            marginTop: "1em",
            justifyContent: "center",
          }}
        >
          <Button
            type="button" // importante para no disparar submit
            content="Añadir"
            primary
            size="small"
            style={{ minWidth: 100 }}
            onClick={handleAddComment}
          />
          <Button
            type="button" // importante para no disparar submit
            content={t("close")}
            secondary
            size="small"
            style={{ minWidth: 100 }}
            onClick={onClose}
          />
        </div>
      </Form>
    </CommentGroup>
  );
}
function EditableComment({ id, author, date, content, onSave, active, t }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedContent, setEditedContent] = useState(content);

  const handleChange = (e) => setEditedContent(e.target.value);
  const handleEdit = () => setIsEditing(true);
  const handleCancel = () => {
    setEditedContent(content);
    setIsEditing(false);
  };
  const handleSave = () => {
    if (editedContent.trim()) {
      onSave(id, editedContent);
      setIsEditing(false);
    }
  };

  const initials = author
    ? author.split(' ').map((n) => n[0]).join('').slice(0, 2).toUpperCase()
    : '?';

  return (
    <div style={{
      display: 'flex',
      gap: '10px',
      padding: '10px 12px',
      borderRadius: '10px',
      backgroundColor: '#f4f6f9',
      marginBottom: '8px',
    }}>
      <div style={{
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        backgroundColor: '#648EBC',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '13px',
        fontWeight: '700',
        flexShrink: 0,
      }}>
        {initials}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', marginBottom: '4px' }}>
          <span style={{ fontWeight: '700', fontSize: '13px', color: '#1A1C40' }}>{author}</span>
          <span style={{ fontSize: '11px', color: '#999' }}>{date}</span>
        </div>
        {isEditing ? (
          <Form reply>
            <Form.TextArea value={editedContent} onChange={handleChange} rows={3} />
            <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem", justifyContent: "center" }}>
              <Button type="button" icon="check" circular primary className="btn-comment-edit-action" onClick={handleSave} />
              <Button type="button" icon="times" circular secondary className="btn-comment-edit-action" onClick={handleCancel} />
            </div>
          </Form>
        ) : (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '8px' }}>
            <p style={{ margin: 0, fontSize: '13px', color: '#333', wordBreak: 'break-word' }}>{content}</p>
            {active && (
              <Icon
                name="pencil"
                size="small"
                style={{ cursor: 'pointer', color: '#aaa', flexShrink: 0, marginTop: '2px' }}
                onClick={handleEdit}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function FileViewer(props) {
  const { fileName, fileUniqueName, handleRemove, t } = props;
  const [fileUrl, setFileUrl] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);

  useEffect(() => {
    if (fileName) {
      const url = wasteFormController.getFileApi(fileUniqueName);
      setFileUrl(url);
    }
  }, [fileName]);

  const handleOpenPreview = (event) => {
    event.preventDefault();
    setPreviewOpen(true);
  };

  const handleClosePreview = (event) => {
    event.preventDefault(); // Previene el comportamiento predeterminado
    setPreviewOpen(false);
  };

  return (
    <>
      <List.Content floated="left">{fileName}</List.Content>
      <List.Content floated="right">
        {" "}
        <Button
          color="red"
          onClick={() => handleRemove(fileUniqueName)}
          icon="trash alternate"
        />
      </List.Content>
      {/* //<Button onClick={handleOpenPreview}> {fileName}</Button> */}
      <List.Content floated="right">
        <Modal
          onClose={handleClosePreview}
          onOpen={handleOpenPreview}
          open={previewOpen}
          trigger={
            <Button primary icon>
              <Icon name="eye" />
            </Button>
          }
        >
          <ModalHeader>{fileName}</ModalHeader>
          <ModalContent>
            {fileName &&
              (fileName.endsWith(".jpg") ||
                fileName.endsWith(".png") ||
                fileName.endsWith(".jpeg")) && (
                <Image
                  src={fileUrl}
                  alt="Vista previa"
                  style={{ maxWidth: "100%" }}
                />
              )}
            {fileName && fileName.endsWith(".pdf") && (
              <iframe
                src={fileUrl}
                title={t("preview")}
                style={{ width: "100%", height: "500px" }}
              />
            )}
          </ModalContent>
          <ModalActions>
            {/* <Button color="red" onClick={() => handleRemove(fileName)}>
            <Icon disabled name="trash alternate" /> Eliminar
          </Button> */}
            <Button color="black" onClick={handleClosePreview}>
              <Icon disabled name="close" />
              {t("close")}
            </Button>
          </ModalActions>
        </Modal>
      </List.Content>
    </>
  );
}

function FileUpload(props) {
  const { accessToken, data, field, newFiles, setNewFiles, t } = props;
  const [files, setFiles] = useState([]);
  const [filesView, setFilesView] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [openModal, setOpenModal] = useState(false); // Para controlar el estado del modal

  useEffect(() => {
    if (data.values[field].files) {
      setFilesView(data.values[field].files); // Construye la URL del archivo
    }
  }, [data.values[field].files]);

  const handleButtonClick = (event) => {
    event.preventDefault(); // Evita que el formulario se envíe
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    input.onchange = handleFileChange;
    input.click();
  };

  // Maneja el cambio cuando se seleccionan archivos
  const handleFileChange = async (e) => {
    e.preventDefault(); // Evita que el formulario se envíe
    const selectedFiles = e.target.files;
    setNewFiles({ ...newFiles, [field]: Array.from(selectedFiles) });
    //data.setFieldValue(`${field}.files`,Array.from(selectedFiles))
    setFiles([...selectedFiles]);
  };

  // Función para cerrar el modal
  const closeModal = (event) => {
    event.preventDefault();
    setOpenModal(!openModal);
  };

  const handleRemoveFile = async (file) => {
    try {
      const updatedFiles = filesView.filter((f) => f.uniqueName !== file);
      setFilesView(updatedFiles);
      const response = await wasteFormController.deleteFileApi(
        accessToken,
        file
      );
      //setMessage(response.message);
      removeFile(updatedFiles);
    } catch (error) {
      // setMessage('Error al elimianr el archivo');
    }
  };

  const removeFile = async (updatedFiles) => {
    data.setFieldValue(`${field}.files`, updatedFiles);
  };

  return (
    <>
      {/* Input para seleccionar los archivos */}
      {/* <Input
        type="file"
        multiple
        icon={"paperclip"}
        onChange={handleFileUpload}
      /> */}

      <Popup
        content={t("upload_file")}
        trigger={
          <Button
            default
            onClick={handleButtonClick}
            style={{ marginTop: "10px" }}
            color={files.length > 0 ? "green" : "grey"}
          >
            <img src={vector71Icon} alt="upload" style={{ width: 14, height: 14, filter: "brightness(0) invert(1)" }} />
          </Button>
        }
      />

      {/* Mensajes de éxito o error */}
      {successMessage && (
        <Message success>
          <Message.Header>Éxito</Message.Header>
          <p>{successMessage}</p>
        </Message>
      )}

      {errorMessage && (
        <Message error>
          <Message.Header>Error</Message.Header>
          <p>{errorMessage}</p>
        </Message>
      )}

      <Popup
        content={t("view_file")}
        trigger={
          <Button
            primary
            onClick={closeModal}
            style={{ marginTop: "10px" }}
          >
            <img src={viewIcon} alt="view" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
          </Button>
        }
      />
      {/* Modal para mostrar los archivos subidos */}
      <BasicModal show={openModal} close={closeModal} title="Archivos subidos" size="tiny">
          <List divided>
            {filesView.length > 0 && (
              <>
                <Header as="h4">Archivos existentes</Header>
                {filesView.map((filePath, index) => (
                  <List.Item key={index}>
                    {/* <a href={`/${filePath.url}`} target="_blank" rel="noopener noreferrer">
                        {filePath.url}
                      </a> */}

                    <FileViewer
                      fileName={filePath.name}
                      fileUniqueName={filePath.uniqueName}
                      handleRemove={handleRemoveFile}
                      t={t}
                    />
                  </List.Item>
                ))}
              </>
            )}
            {newFiles[field] && newFiles[field].length > 0 && (
              <>
                <Header as="h4">
                  Archivos nuevos (se guardarán al enviar)
                </Header>
                {newFiles[field].map((file, index) => (
                  <List.Item key={`new-${index}`}>
                    <List.Content floated="left">{file.name}</List.Content>
                    <List.Content floated="right">
                      <Button
                        color="blue"
                        onClick={() => window.open(URL.createObjectURL(file), '_blank')}
                        icon="eye"
                      />
                      <Button
                        color="red"
                        onClick={() => {
                          const updatedNewFiles = newFiles[field].filter(
                            (_, i) => i !== index
                          );
                          setNewFiles({
                            ...newFiles,
                            [field]: updatedNewFiles,
                          });
                        }}
                        icon="trash alternate"
                      />
                    </List.Content>
                  </List.Item>
                ))}
              </>
            )}
            {filesView.length === 0 &&
              (!newFiles[field] || newFiles[field].length === 0) && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.5em",
                    color: "#9e9e9e",
                    padding: "2em 0",
                  }}
                >
                  <Icon name="file outline" size="big" />
                  <span>No se encontraron archivos subidos.</span>
                </div>
              )}
          </List>
          <div className="view-files-actions" style={{ display: 'flex', justifyContent: 'center', marginTop: '1.5em' }}>
            <Button secondary size="small" style={{ minWidth: 100 }} onClick={closeModal}>{t("close")}</Button>
          </div>
      </BasicModal>
    </>
  );
}
